/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Week_Session_TitleInputs */

const en_portal_week_session_title = /** @type {(inputs: Portal_Week_Session_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1:1 session with Kasia`)
};

const pl_portal_week_session_title = /** @type {(inputs: Portal_Week_Session_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trening 1:1 z Kasią`)
};

/**
* | output |
* | --- |
* | "1:1 session with Kasia" |
*
* @param {Portal_Week_Session_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_week_session_title = /** @type {((inputs?: Portal_Week_Session_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Week_Session_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_week_session_title(inputs)
	return en_portal_week_session_title(inputs)
});